<template>
  <article class="day-meal-article">
    <draggable
      class="list-group planned-meal"
      :class="{ drag: isPlannedMealDragged }"
      :delay="500"
      :delayOnTouchOnly="true"
      :disabled="!updatable"
      group="people"
      v-model="plannedMealsSorted"
      v-bind="dragOptions"
      @start="setDrag(true)"
      @end="setDrag(false)"
    >
      <DayMealItem
        v-for="(plannedMeal, index) in plannedMealsSorted"
        :key="index"
        :plannedMeal="plannedMeal"
        :updatable="updatable"
        :selectable="selectable"
        @click="(id) => updateMeal(id)"
        @delete="(id) => removeMeal(id)"
        @select="(id) => selectMeal(id)"
      />
    </draggable>
    <button
      class="circle-btn"
      v-if="updatable"
      @click="addMeal()"
      type="submit"
    >
      <Icon icon="fas fa-plus" />
    </button>
  </article>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import draggable from 'vuedraggable';

import * as fb from '../../firebase';
import DayMealItem from './DayMealItem.vue';
import ChooseMeal from '../Meals/ChooseMeal.vue';

import plannedMealsService from '../../services/plannedMeals.service';

export default {
  components: {
    DayMealItem,
    draggable,
  },
  props: {
    day: { required: true },
    mealTime: { required: true },
    updatable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedMealsId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      plannedMeals: [],
      snapshotUnsub: [],
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      },
    };
  },
  mounted() {
    this.getPlannedMeal();
  },
  destroyed() {
    this.unsubAll();
  },
  methods: {
    getPlannedMeal() {
      this.unsubAll();
      if (!this.currentWorkspaceRef) {
        return;
      }

      const snapshotUnsub = fb.plannedMealsCollection
        .where('workspace', '==', this.currentWorkspaceRef)
        .where('date', '==', this.day.startOf('day').toDate())
        .where('mealTime', '==', this.mealTime)
        .orderBy('order')
        .onSnapshot((snapshot) => {
          this.plannedMeals = [];
          snapshot.forEach((doc) => {
            const plannedMeal = doc.data();
            plannedMeal.id = doc.id;
            // Sélectionné par défaut ?
            plannedMeal.selected = this.selectedMealsId.includes(
              plannedMeal.id
            );
            // On récupère le vrai meal au cas où il aurait changé
            this.getMealObject(plannedMeal);
          });
        });

      this.snapshotUnsub.push(snapshotUnsub);
    },
    getMealObject(plannedMeal) {
      const mealId = plannedMeal.meal.id;
      // On ne subscribe pas au meal, que au planned meal
      fb.mealsCollection
        .doc(mealId)
        .get()
        .then((doc) => {
          // On retrouve notre meal
          // S'il existe, on lui met les bonnes valeurs
          if (doc.exists) {
            const meal = doc.data();
            plannedMeal.isMealDeleted = false;
            // MAJ data
            plannedMeal.meal.title = meal.title;
            plannedMeal.meal.img = meal.img;
          } else {
            plannedMeal.isMealDeleted = true;
          }
          const index = _.findIndex(
            this.plannedMeals,
            (planned) => planned.id === plannedMeal.id
          );
          if (index > -1) {
            // On regarde si déjà existant
            this.plannedMeals[index] = plannedMeal;
          } else {
            // ajoute à la liste
            this.plannedMeals.push(plannedMeal);
          }
        });
    },
    unsubAll() {
      this.snapshotUnsub.forEach((unsub) => unsub());
    },

    addMeal() {
      this.chooseMeal();
    },
    updateMeal(id) {
      this.chooseMeal(id);
    },
    /**
     * Quand on clique sur un meal en mode sélection
     */
    selectMeal(id) {
      const index = _.findIndex(this.plannedMeals, (m) => m.id === id);
      if (index > -1) {
        // On prend l'inverse de selected
        // Si selected n'existe pas, on le met à false pour qu'il passe à true
        this.plannedMeals[index].selected = !_.get(
          this.plannedMeals[index],
          'selected',
          false
        );
      }
    },
    /**
     * Sélectionne tous les meals de ce DayMeal
     */
    selectAllMeals() {
      this.plannedMeals.forEach((m) => {
        m.selected = true;
      });
    },
    /**
     * Return tous les planned meals selected
     */
    getSelectedPlannedMeals() {
      return this.plannedMeals.filter((m) => m.selected === true);
    },
    /**
     * Ajoute ou modifie un plannedMeal (popup)
     */
    chooseMeal(plannedMealId = null) {
      this.$modal.show(
        ChooseMeal,
        {
          day: this.day,
          mealTime: this.mealTime,
          plannedMealId,
          nbItems: this.plannedMeals.length,
        },
        {
          height: 'auto',
          width: '90%',
          scrollable: true,
        }
      );
    },
    removeMeal(id) {
      plannedMealsService.removePlannedMeal(id);
    },
    setDrag(isDragged) {
      this.$store.dispatch('setIsPlannedMealDragged', isDragged);
    },
  },
  computed: {
    plannedMealsSorted: {
      get() {
        return this.plannedMeals.slice().sort((a, b) => a.order - b.order);
      },
      set(orderedMeals) {
        // On prend chaque meal
        _.forEach(orderedMeals, (orderedMeal, newOrder) => {
          // on trouve l'index dans l'objet
          // const mealIndex = _.findIndex(
          //   this.plannedMeals,
          //   (meal) => meal.id === orderedMeal.id
          // );
          fb.plannedMealsCollection.doc(orderedMeal.id).update({
            updatedOn: moment().toDate(),
            date: this.day.startOf('day').toDate(),
            mealTime: this.mealTime,
            order: newOrder,
          });
        });
      },
    },
  },
  watch: {
    currentWorkspace() {
      this.getPlannedMeal();
    },
    day() {
      this.getPlannedMeal();
    },
  },
};
</script>

<style lang="scss" scoped src="./DayMeal.scss"></style>
